import { render } from "./formPreview.vue?vue&type=template&id=0ac7d1c2&scoped=true"
import script from "./formPreview.vue?vue&type=script&lang=js"
export * from "./formPreview.vue?vue&type=script&lang=js"

import "./formPreview.vue?vue&type=style&index=0&id=0ac7d1c2&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac7d1c2"]])

export default __exports__